import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";

import { actionToLog } from "../store/ducks/duckAudit";

const VIEW = "VIEW";
const regex = /(\d+)/g;

const Logger = () => {
  const { listen } = useHistory();
  const dispatch = useDispatch();
  const paths = useSelector((state) => state.sidebar.paths);

  useEffect(() => {
    const unlisten = listen((location, _action) => {
      let pathName = location.pathname;
      let pathMenu = pathName;

      if (regex.test(pathName)) {
        let conci = pathName.match(regex);

        let id = conci[0];

        id = parseInt(id, 10);

        if (paths && pathName.includes("Layout/") && pathName.match(regex)) {
          pathMenu = paths[id];
        }
        //Es de tipo view porque acá se loguea las paginas buscadas

        if (_action === "PUSH") {
          dispatch(
            actionToLog({
              action: "DEFAULT",
              pathMenu,
              resource: pathName.includes("Layout/")
                ? "Layout"
                : pathName.includes("Administration/")
                  ? "Administration"
                  : "Custom Page",
              resourceId: pathName.includes("Layout/") ? id : 0,
              details: null,
              category: VIEW,
            }),
          );
        }
      }
    });

    return () => unlisten();
  }, [listen, dispatch, paths]);

  //No renderiza nada.
  return null;
};

export default Logger;
